<template>
  <el-dialog
    :visible.sync="visible"
    size="tiny"
    @close="handleClose"
  >
    <span
      slot="title"
      class="save-block-title"
    >
      Save Page
    </span>
    <div class="row">
      <el-input
        v-model="pageName"
        class="col-12 mb-2"
        placeholder="Name the Page"
        autofocus
      />
      <el-input
        v-model="pageThumbnail"
        class="col-12 mb-2"
        placeholder="Thumbnail the Page"
      />

      <el-select
        v-model="pageTag"
        class="col-12"
        filterable
        allow-create
        placeholder="Apply Page tags"
      >
        <el-option
          v-for="tag in pageTags"
          :key="tag"
          :label="tag"
          :value="tag"
        />
      </el-select>
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <div class="row">
        <cvt-switch
          class="col-1"
          size="sm"
          color="active"
          type="circular"
          description-type="default"
          :initial-state="false"
          @switchToggle="(e) => savePageGlobally(e)"
        />
        <span class="col-2">Save globally</span>
        <div class="col-9 mr-0">
          <el-button
            @click="handleClose"
          >Cancel</el-button>
          <el-button
            type="primary"
            @click="savePage"
          >Confirm</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import * as _ from 'lodash'
import * as getters from '../../../store/modules/getters'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data () {
    return {
      pageName: '',
      pageThumbnail: '',
      pageTag: '',
      loading: false,
      globalSavePageFlag: false,
      pageTags: ['Thank you', 'Opt-in', 'Sales Page', 'Checkout Page', 'Upsell Page', 'Downsell Page', 'Content Page',
        'Survey', 'Webinar', ' Webinar Registration', ' Webinar Live', ' Webinar Replay',
        ' Webinar Sales', ' Application Page', ' Calendar Invite Page']
    }
  },
  computed: {
    ...mapState({
      site: ({ site }) => _.get(site, 'site'),
      theme: ({ theme }) => theme,
    }),
    ...mapState('pageManager', {
      page: 'page',
      pageObject: 'pageObject',
      visible: 'saveVisible',
    }),
    ...mapGetters({
      vdom: getters.DELTA_VDOM,
    }),
    isGridBuilder () {
      const version = _.get(this.site, 'version')
      return version === 'v2'
    },
    themeColors () {
      return {
        ...this.theme.colors,
        ...this.theme.blockColors
      }
    },
  },
  methods: {
    ...mapMutations('pageManager', {
      handleClose: 'closeSave',
    }),
    ...mapActions('pageManager', {
      savePageToFirebase: 'savePageToFirebase',
    }),
    async savePage () {

      this.loading = true
      const paletteColors = this.getPaletteColorsFromCurrentSite()

      const pageProps = {
        pageName: this.pageName,
        pageThumbnail: this.pageThumbnail,
        pageTag: this.pageTag,
        global: this.globalSavePageFlag,
        isGridBuilder: this.isGridBuilder,
        meta: {
          colors: paletteColors,
          clonedFromSiteRef: this.site.firebaseRef,
          clonedFromPageRef: this.pageObject.firebaseRef,
        }
      }

      try {
        await this.savePageToFirebase({pageProps})
      } finally {
        this.loading = false
        this.handleClose()
      }
    },
    savePageGlobally (e) {
      if (e === 'Active') this.globalSavePageFlag = true
      else if (e === 'Inactive') this.globalSavePageFlag = false
    },
    getPaletteColorsFromCurrentSite () {
      const paletteColors = {};

      this.vdom.forEach((node) => {

        let backgroundColorId    = _.get(node, 'data.props.themeColorId', null);
        let backgroundColorAlpha = _.get(node, 'data.props.themeColorAlpha', 1);
        let backgroundColorObj   = this.themeColors[backgroundColorId];

        let overlayColorId       = _.get(node, 'data.props.background.coloroverlay', null);
        let overlayColorAlpha    = _.get(node, 'data.props.background.coloralpha', 1);
        let overlayColorEnabled  = _.get(node, 'data.props.background.overlay', false);
        let overlayColorObj      = this.themeColors[overlayColorId];


        if(backgroundColorId && backgroundColorObj) {
          paletteColors[backgroundColorId] =  {
            hex: backgroundColorObj.hex(),
            rgb: backgroundColorObj.rgb(),
            hsl: backgroundColorObj.hsl(),
            alpha: backgroundColorAlpha >= 0 ? backgroundColorAlpha : 1,
          }
        }

        if(overlayColorId && overlayColorObj && overlayColorEnabled) {
          paletteColors[overlayColorId] =  {
            hex: overlayColorObj.hex(),
            rgb: overlayColorObj.rgb(),
            hsl: overlayColorObj.hsl(),
            alpha: overlayColorAlpha >= 0 ? overlayColorAlpha : 1,
          }
        }
      })

      return paletteColors;
    }
  },
}
</script>

<style lang="scss">
</style>
